import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { _SCREEN_MIRRORING_STORE } from '@/values/screen.mirroring.values';

export const SCREEN_MIRRORING_STORE = _SCREEN_MIRRORING_STORE; 

@Module({ namespaced: true })
export class ScreenMirroringStore extends VuexModule {

  /* State */
  public clientId: string;
  public mode: string;

  /* Mutations */
  @Mutation
  public setClientId(clientId:string){
    this.clientId = clientId;
  }

  @Mutation
  public setMode(mode:string){
      this.mode = mode;
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.clientId = null;
    this.mode = null;
  }
}